import * as R from 'ramda'
import URI from 'urijs'
import Vue from 'vue'
import { makeCancellable, takeLatest } from 'vuex-cancellable-actions'

import { collectToLookup, mapOverKeys } from '../../helpers'
import { apiGet } from '../api'

export default { // events for chart
  namespaced: true,
  state: {
    MAX_RECORDS: 20000, // max number of records per request
    LOAD_MORE_RECORDS: 10000,
    map: null, // {'1': { 'id': 1, ... }, '2': { ... } }
    serverOrder: null, // [1, 2]
    total: null, // Общее кол-во событий на сервере
    loading: false, // загрузка списка событий
  },
  getters: {
    events: (state) => state.serverOrder && state.map && state.serverOrder
      .map(eventId => state.map[eventId]),
    event: (state) => eventId => state.map && (state.map[eventId] || null),
    // undefined - not loaded, null - server doesn't know, str - url
    url: (state, getters) => eventId =>
      (getters.event(eventId) || {}).externalUrl,
  },
  mutations: {
    setLoading: (state, { value }) => { state.loading = !!value },
    setList: (state, { events, total, eventTypes = {} }) => {
      events = events && events.map(e => ({ ...e, type: eventTypes[e.typeCode] }))
      state.map = events ? collectToLookup('id', events) : null
      state.serverOrder = events ? events.map(e => e.id) : null
      state.total = total || null
    },
    setDetails: (state, { event, eventType }) => {
      state.map = state.map || {}
      event.type = eventType
      Vue.set(state.map, event.id, event)
    },
    addToList: (state, { events, total, eventTypes = {} }) => {
      events = events.map(e => ({ ...e, type: eventTypes[e.typeCode] }))
      state.map = {
        ...state.map,
        ...collectToLookup('id', events),
      }
      state.serverOrder = R.uniq([
        ...state.serverOrder,
        ...events.map(e => e.id),
      ])
      state.total = total
    },
  },
  actions: makeCancellable({
    getList: takeLatest((
      { state, rootState, commit, dispatch },
      {
        // filter: {
        //   dtStart: '2020-01-01', dtEnd: '2020-01-02T12:23:15.666Z',
        //   type: 'email-read,incoming-call',
        //   tags: 'foo,bar',
        //   tagsLogic: 'and',
        //   userId: '1,2,3',
        // }
        filter = {},
        sort = null, // 'id', '-id', '-started'
        limit = null,
        offset = null,
      } = {},
    ) => {
      if (!rootState.auth.token) {
        return Promise.reject(new Error('requires auth'))
      }

      const query = mapOverKeys(key => `filter[${key}]`, filter)
      if (sort) query.sort = sort
      if (limit !== null) query.limit = limit
      if (offset !== null) query.offset = offset
      const url = URI('/api/event/get_list/').addQuery(query).toString()
      const types = () => rootState.eventType.map

      commit('setLoading', { value: true })
      return dispatch('eventType/get', { reload: true }, { root: true })
        .then(() => apiGet({ url, rootState, dispatch }))
        .then(({ res: events, total }) =>
          offset
            ? commit('addToList', { events, total, eventTypes: types() })
            : commit('setList', { events, total, eventTypes: types() }))
        .finally(() => commit('setLoading', { value: false }))
    }),
    get: (
      { state, rootState, commit, dispatch },
      { eventId, reload = false },
    ) => {
      if (!reload && state.map.hasOwnProperty(eventId)) {
        return Promise.resolve()
      }
      const type = e => rootState.eventType.map[e.typeCode]
      return dispatch('eventType/get', { reload: true }, { root: true })
        .then(() => apiGet({
          url: `/api/event/get/${eventId}/`,
          rootState,
          dispatch,
        }))
        .then(({ res: event }) =>
          commit('setDetails', { event, eventType: type(event) })
        )
    },
  }),
}
